import { MINUTE } from '@hsp/utilities';

export const defaultSessionTime = parseInt(process.env.REACT_APP_SESSION_TIME ?? `${MINUTE * 60}`);
